import {AppApiService} from "./app-api.service";
import type {SpecialistListResponse} from "../models/interfaces/specialist-list-response.interface";
import type {SpecialistDTO} from "../models/interfaces/specialist-dto.interface";
import type {CreateSpecialistRequest} from "../models/interfaces/create-specialist-request.interface";
import {UpdateSpecialistRequest} from "../models/interfaces/update-specialist-request.interface";
import type {SpecialistProfileImageResponse} from "../models/interfaces/specialist-profile-image-response.interface";
import type {UpdateSpecialistProfileImageRequest} from "../models/interfaces/update-specialist-profile-image-request.interface";

class SpecialistApiService extends AppApiService {
    public async getSearchSpecialists(filter: string = "", limit: number = 20, offset: number = 0): Promise<SpecialistListResponse> {
        return await this.get<SpecialistListResponse>(`/specialist/search`, {
            params: {filter, limit, offset},
            errorMessage: "Błąd podczas pobierania specjalistów"
        })
            .catch((error) => {
                throw error;
            });
    }

    public async getSpecialistById(id: string): Promise<SpecialistDTO> {
        return await this.get<SpecialistDTO>(`/specialist/${id}`, {
            errorMessage: "Błąd podczas pobierania specjalisty"
        })
            .catch((error) => {
                throw error;
            });
    }

    public async createSpecialist(data: CreateSpecialistRequest, image?: File): Promise<SpecialistDTO> {
        const formData = new FormData();

        formData.append('dto', new Blob([JSON.stringify(data)], {type: "application/json"}));

        if (image) {
            formData.append('image', image);
        }

        return await this.post<SpecialistDTO>(`/specialist`, formData, {
            errorMessage: "Błąd podczas tworzenia specjalisty",
            successMessage: "Specjalista został utworzony pomyślnie",
        })
            .catch((error) => {
                throw error;
            });
    }

    public async updateSpecialist(data: UpdateSpecialistRequest): Promise<SpecialistDTO> {
        return await this.put<SpecialistDTO>(`/specialist`, data, {
            errorMessage: "Błąd podczas aktualizacji specjalisty",
            successMessage: "Specjalista został pomyślnie zedytowany",
        })
            .catch((error) => {
                throw error;
            });
    }

    public async deleteSpecialist(id: string): Promise<void> {
        return await this.delete<void>(`/specialist/${id}`, {
            errorMessage: "Błąd podczas usuwania specjalisty",
            successMessage: "Specjalista został usunięty pomyślnie",
            skipDefault404Handling: true,
        })
            .catch((error) => {
                throw error;
            });
    }

    public async getSpecialistProfileImage(id: string): Promise<SpecialistProfileImageResponse> {
        return await this.get<SpecialistProfileImageResponse>(`/specialist/${id}/image`, {
            errorMessage: "Błąd podczas pobierania zdjęcia specjalisty",
            skipDefault404Handling: true,
            skipDefaultErrorHandling: true,
        })
            .catch((error) => {
                throw error;
            });
    }

    public async updateSpecialistProfileImage(id: string, image: File): Promise<void> {
        const formData = new FormData();
        formData.append('image', image);

        return await this.put<void>(`/specialist/${id}/image`, formData, {
            errorMessage: "Błąd podczas aktualizacji zdjęcia specjalisty",
            successMessage: "Zdjęcie specjalisty zostało zaktualizowane pomyślnie"
        })
            .catch((error) => {
                throw error;
            });
    }
}

export default new SpecialistApiService();
